import React, { useEffect } from "react";

import TopNav from "containers/navs/Topnav";
import Sidebar from "containers/navs/Sidebar";
import Footer from "containers/navs/Footer";

/**
 * `noFooter` is for pages whose content runs to the bottom of the window: the
 * footer is positioned absolutely against the body, so on a long page it sits on
 * top of whatever is last. The theme's `no-footer` class also gives back the
 * 90px the body reserves for it, which would otherwise be left as a gap.
 */
const AppLayout = ({ children, noFooter = false }) => {
  useEffect(() => {
    if (!noFooter) return undefined;
    document.body.classList.add("no-footer");
    return () => document.body.classList.remove("no-footer");
  }, [noFooter]);

  return (
    <div id="app-container">
      <TopNav />
      <Sidebar />
      <main>
        <div className="container-fluid">{children}</div>
      </main>
      {!noFooter && <Footer />}
    </div>
  );
};

export default AppLayout;
